function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { fetchAccessTokens } from '@shared/msal/tokens';
export const getAccessTokenCB = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(store) {
        return yield fetchAccessTokens({
            resources: [
                'spza',
                'arm',
                'graph',
                'marketplaceLeads',
                'agreement'
            ]
        });
    });
    return function getAccessTokenCB(store) {
        return _ref.apply(this, arguments);
    };
}();
